
import template from './Message.html';

class MessageVM
{
	constructor(toast)
	{
		this.toast = toast;
		this.toast_delay = toast.bindings.toast_delay;
		this.link = ko.observable(toast.bindings.link || '');
		this.message = ko.observable(toast.bindings.message || '');
		this.type_class = ko.observable(toast.bindings.class || '');
		this.icon = ko.observable(toast.bindings.icon || '');
		setTimeout(()=>{this.close()}, toast.bindings.delay ?? 3000); //should match css var --toast-delay
		this.quickClose = (data, event)=>{
			event.preventDefault();
			if (event.buttons & 1)
				this.close();
		};
	}

	navigate(){
		Grape.navigate(this.link());
		this.close();
	}

	close(){
		this.toast.close();
	}
}

class MessageToast
{
	constructor(bindings, element)
	{
		element.style.setProperty('--toast-delay', `${(bindings.delay ?? 3000)/1000}s`);
		element.classList.add(bindings.class);
		this.bindings = bindings || {};
		this.viewModel = new MessageVM(this); // Name of the ViewModel defined above
	}
}

export default {
	name: 'Message',
	toast_class: MessageToast,
	provider: 'ps',
	template: template
}
